(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["full-home-automation"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fha-solutions-tabs')) {
    class FhaSolutionsTabs extends HTMLElement {
      connectedCallback() {
        const tabs = this.querySelectorAll('.fha-solutions__tab');
        const panels = this.querySelectorAll('.fha-solutions__panel');

        tabs.forEach((tab) => {
          tab.addEventListener('click', () => {
            const id = tab.dataset.tab;
            tabs.forEach((t) => {
              t.classList.toggle('is-active', t === tab);
              t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
            });
            panels.forEach((panel) => {
              const active = panel.dataset.panel === id;
              panel.classList.toggle('is-active', active);
              if (active) {
                panel.removeAttribute('hidden');
              } else {
                panel.setAttribute('hidden', '');
              }
            });
          });
        });
      }
    }
    customElements.define('fha-solutions-tabs', FhaSolutionsTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-smart-automation"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('smart-automation-media')) {
    class SmartAutomationMedia extends HTMLElement {
      connectedCallback() {
        const video = this.querySelector('video');
        if (!video) return;

        video.controls = false;
        video.muted = true;
        video.setAttribute('playsinline', '');
        video.setAttribute('disablepictureinpicture', '');

        const posterUrl = this.dataset.poster;
        if (posterUrl) {
          video.poster = posterUrl;
        }

        const section = this.closest('section');
        let isInView = false;
        let isHovering = false;

        const updatePlayback = () => {
          if (isInView || isHovering) {
            if (window.TechnixiaLazyVideo) {
              window.TechnixiaLazyVideo.activate(video);
            } else {
              video.play().catch(() => {});
            }
          } else {
            video.pause();
          }
        };

        this.addEventListener('mouseenter', () => {
          isHovering = true;
          updatePlayback();
        });

        this.addEventListener('mouseleave', () => {
          isHovering = false;
          updatePlayback();
        });

        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              isInView = entry.isIntersecting;
              updatePlayback();
            });
          },
          { threshold: 0.35 }
        );

        observer.observe(section || this);

        video.addEventListener('error', () => {
          const posterUrl = this.dataset.poster;
          if (!posterUrl || this.querySelector('.home-smart-automation__video-fallback')) return;

          const fallback = document.createElement('img');
          fallback.className = 'home-smart-automation__image home-smart-automation__video-fallback img-fluid';
          fallback.src = posterUrl;
          fallback.alt = '';
          fallback.loading = 'lazy';
          this.appendChild(fallback);
          video.style.display = 'none';
        });
      }
    }

    customElements.define('smart-automation-media', SmartAutomationMedia);
  }

  } catch(e) { console.error(e); }
})();
})();
